/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:site_name`,
          content: `Computers and Composition Digital Press`,
        },
        {
          property: `og:image`,
          content: `https://www.ccdigitalpress.org/book/arewethereyet/assets/are-we-there-yet-cover.png`,
        },
        {
          name: `citation_author`,
          content: `Jennifer Marlow`,
        },
        {
          name: `citation_author`,
          content: `James P. Purdy`,
        },
        {
          name: `citation_date`,
          content: `2021`,
        },
        {
          name: `citation_title`,
          content: `Are We There Yet?: Computers and the Teaching of Writing in American Higher Education–Twenty Years Later`,
        },
        {
          name: `citation_publisher`,
          content: `Computers and Composition Digital Press/Utah State University Press`,
        },
        {
          name: `citation_isbn`,
          content: `9781646422401`,
        },
        {
          name: `citation_language`,
          content: `en`,
        },
        {
          name: `DC.title`,
          content: `Are We There Yet?: Computers and the Teaching of Writing in American Higher Education–Twenty Years Later`,
        },
        {
          name: `DC.creator`,
          content: `Jennifer Marlow`,
        },
        {
          name: `DC.creator`,
          content: `James P. Purdy`,
        },
        {
          name: `DC.type`,
          content: `text`,
        },
        {
          name: `DC.format`,
          content: `text/html`,
        },
        {
          name: `DC.language`,
          content: `en`,
        },
        {
          name: `DC.publisher`,
          content: `Computers and Composition Digital Press/Utah State University Press`,
        },
        {
          name: `DC.source`,
          content: `urn:ISBN:9781646422401`,
        },
        {
          name: `DC.date`,
          content: `2021`,
        },
        {
          name: `DC.description`,
          content: `Are We There Yet? Computers and the Teaching of Writing in American Higher Education—Twenty Years Later celebrates the landmark text Computers and the Teaching of Writing in American Higher Education, 1979–1994: A History by Gail E. Hawisher, Cynthia L. Selfe, Paul LeBlanc, and Charles Moran. Published in 1996, the book provided a history of how computers “entered and changed” writing studies while also documenting “how people in the field used computers” (p. 2). Are We There Yet? continues this history of computers and writing from 1995 to 2015. Just as Hawisher et al. (1996) recognized that there are many separate histories within the story they seek to tell, so do we. There is no one “correct” history, and we do not endeavor to provide that here. Rather, we follow in the footsteps of Hawisher et al. in describing how scholars, teachers, graduate students, and administrators have continued to define (as well as debate) the (sub)field of computers and writing as an important site of research, technology, and pedagogy.`,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
